import React, { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const PhoneIconInCart = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => {
  return <svg fill="none" viewBox="0 0 20 20" {...props} ref={ref}>
      <g clip-path="url(#a)">
        <path fill="#e05109" d="m17.337 12.372-3.663-1.562a1.22 1.22 0 0 0-1.18.102l-1.96 1.304a5.98 5.98 0 0 1-2.75-2.734l1.297-1.984a1.24 1.24 0 0 0 .11-1.18L7.62 2.656a1.27 1.27 0 0 0-1.305-.75 4.39 4.39 0 0 0-3.82 4.343c0 6.202 5.046 11.248 11.248 11.248a4.39 4.39 0 0 0 4.343-3.82 1.27 1.27 0 0 0-.75-1.304" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h19.997v19.997H0z" />
        </clipPath>
      </defs>
    </svg>;
});
export default PhoneIconInCart;